<template>
  <Modal :modal="groupSettingsModalRef" :steps="[{ component: GroupSettingsModalContent, id: 'group-settings' }]" />
</template>

<script lang="ts" setup>
import GroupSettingsModalContent from '@/features/groups/components/group-settings-modal/group-settings-modal-content/group-settings-modal-content.vue'
import Modal from '@/features/ui/components/modal/modal.vue'
import { selectGetGroupSettingsModal } from '@/features/ui/store/modal/modal.selectors'
import modalsStore from '@/features/ui/store/modal/modal.store'

const groupSettingsModalRef = selectGetGroupSettingsModal(modalsStore)
</script>
